module.exports = __webpack_public_path__ + "static/media/logo_ge.94747530.svg";